var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-two-content"},[(_vm.statusOneColor)?_c('div',{staticClass:"status",style:({
      backgroundColor: _vm.statusOneColor?.bgcolor,
      borderColor: _vm.statusOneColor?.borderColor,
    })},[_c('span',{style:({ color: _vm.statusOneColor?.color })},[_vm._v(_vm._s(_vm.codeOne))])]):_c('span',[_vm._v("-")]),_vm._v(" "),(_vm.statusTwoColor)?_c('div',{staticClass:"status",style:({
      backgroundColor: _vm.statusTwoColor?.bgcolor,
      borderColor: _vm.statusTwoColor?.borderColor,
    })},[_c('span',{style:({ color: _vm.statusTwoColor?.color })},[_vm._v(_vm._s(_vm.codeTwo))])]):_c('span',[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }